import React, {useEffect, useState} from 'react';
import {Button, Result} from 'antd';
import useLocalization from '../../../Localization';

const ChunkErrorFallback = () => {
  const {ApplicationString} = useLocalization();
  // Offline, a reload only shows the browser's offline page: wait for the
  // connection to come back before enabling it.
  const [isOnline, setIsOnline] = useState(navigator.onLine !== false);
  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);
  return (
    <Result
      status='warning'
      title={ApplicationString['chunkErrorBoundary.title']}
      subTitle={ApplicationString['chunkErrorBoundary.subTitle']}
      extra={
        <Button
          type='primary'
          disabled={!isOnline}
          onClick={() => window.location.reload()}>
          {ApplicationString['chunkErrorBoundary.button.reload']}
        </Button>
      }
    />
  );
};

/**
 * Shows a reload prompt instead of a blank screen when a page fails to load
 * or render. `resetKey` (the current path) clears the error on navigation.
 */
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error) {
    console.error(error);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({hasError: false});
    }
  }

  render() {
    return this.state.hasError ? <ChunkErrorFallback /> : this.props.children;
  }
}

export default ChunkErrorBoundary;
